(function () {


  console.log('Posha theme JS loaded');

  document.addEventListener("DOMContentLoaded", function () {
    const btn = document.getElementById("video-button");
    const screen = document.getElementById("video_screen");
    const screenWrapper = document.getElementById("block-video-screen");

    if (!btn || !screen) return;

    let video = null;

    function createVideo(src) {
      if (video) {
        try {
          video.pause();
        } catch (e) {
        }
        video.remove();
        video = null;
      }

      const v = document.createElement("video");
      v.setAttribute("src", src);
      v.setAttribute("controls", "true");
      v.setAttribute("playsinline", "true");
      v.controls = true;
      v.playsInline = true;
      v.muted = false;
      v.volume = 1.0;
      v.style.width = "100%";
      v.style.height = "auto";
      v.style.objectFit = "cover";

      screen.replaceChildren(v);
      video = v;

      video.addEventListener("loadedmetadata", function() {
        video.muted = false;
        video.volume = 1.0;
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
          });
        }
      }, { once: true });


      video.addEventListener("playing", () => {
        screenWrapper.classList.add("video-active");
        screenWrapper.classList.remove("video-paused");
        btn.classList.remove("paused");
      });


      video.addEventListener("pause", () => {
        screenWrapper.classList.add("video-paused");
        btn.classList.add("paused");
      });
    }

    screenWrapper.addEventListener("mouseenter", () => {
      if (video && !video.paused) btn.classList.add("visible");
    });
    screenWrapper.addEventListener("mouseleave", () => {
      if (video && !video.paused) btn.classList.remove("visible");
    });

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const link = (btn.dataset.link || "").trim();
      if (!link) return;

      if (!video) {
        createVideo(link);
        return;
      }

      if (video.paused) {
        video.play().catch(() => {
        });
      } else {
        video.pause();
      }
    });


    document.addEventListener('DOMContentLoaded', () => {
      const OFFSET = 0;

      document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', function (e) {
          const targetId = this.getAttribute('href').substring(1);
          const target = document.getElementById(targetId);
          if (!target) return;

          e.preventDefault();
          const y = target.getBoundingClientRect().top + window.scrollY - OFFSET;

          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        });
      });
    });
  });



})();


(function(){
  var trigger = document.querySelector('.mobile-menu-trigger');
  var trigger_close = document.querySelector('.mobile-menu-close');

  var menu    = document.getElementById('mobileSubmenu');
  if(!trigger || !menu) return;

  var panel   = menu.querySelector('.mobile-submenu__panel');
  var focusSel= 'a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var lastScroll = 0;

  function lockScroll(){
    lastScroll = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.classList.add('mm-open');
    document.body.style.top = (-lastScroll) + 'px';
  }
  function unlockScroll(){
    document.body.classList.remove('mm-open');
    document.body.style.top = '';
    window.scrollTo(0, lastScroll);
  }

  function openMenu(){
    menu.hidden = false;
    lockScroll();
    trapFocus();
    document.addEventListener('keydown', onKeyDown);
    menu.addEventListener('click', onBackdrop);
  }
  function closeMenu(){
    menu.hidden = true;
    trigger_close.setAttribute('aria-expanded','false');
    unlockScroll();
    releaseFocus();
    trigger_close.focus();
    document.removeEventListener('keydown', onKeyDown);
    menu.removeEventListener('click', onBackdrop);
  }

  function onKeyDown(e){
    if(e.key === 'Escape'){ e.preventDefault(); closeMenu(); }
    if(e.key === 'Tab') cycleFocus(e);
  }
  function onBackdrop(e){
    if(e.target === menu) closeMenu();
  }
  function cycleFocus(e){
    var nodes = panel.querySelectorAll(focusSel);
    if(!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }
  function trapFocus(){ panel.setAttribute('tabindex','-1'); }
  function releaseFocus(){ panel.removeAttribute('tabindex'); }

  trigger.addEventListener('click', function(){
    menu.hidden ? openMenu() : closeMenu();
  });
  trigger_close && trigger_close.addEventListener('click', closeMenu);

  menu.addEventListener('click', function(e){
    if(e.target.closest('.merged-menu a')) closeMenu();
  });
})();
